import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { FinanciamientoApiService } from 'src/app/services/financiamiento-reusable.service';
import { MatAccordion } from '@angular/material/expansion';
import { MediaMatcher } from '@angular/cdk/layout';
import { Globals } from 'src/app/globals';
import { SupplyService } from 'src/app/services/supply.service';
import { VisorDocumentosComponent } from '../visor-documentos/visor-documentos.component';
import { MatDialog } from '@angular/material';

import { DomSanitizer } from '@angular/platform-browser';
import { DialogoConfirmacionComponent } from '../dialogo-confirmacion/dialogo-confirmacion.component';
import { SolicitanteApiService } from 'src/app/services/solicitante.service';
import { Response } from 'src/app/models/response';
import { ParametroApiService } from 'src/app/services/parametro.service';


@Component({
  selector: 'app-datos-solicitante',
  templateUrl: './datos-solicitante.component.html',
  styleUrls: ['./datos-solicitante.component.scss']
})

export class DatosSolicitanteComponent implements OnInit, OnDestroy {
  panelOpenState = false;
  @ViewChild(MatAccordion) accordion: MatAccordion;

  tip_doc = '';

  thumbnail: any;

  dataSource: any[] = [];
  //dsBandeja: any[] = [];
  //dsTemporal: any[] = [];
  filesMap: Map<number, any> = new Map<number, any>();
  selected: any;
  //filesMapTemp: Map<number, any> = new Map<number, any>();
  sizeFile: number = 0;

  datoSolCorrecto: number = 1;

  limitFile: number;
  bandejaId: number;
  estadoTramite: string;
  secuenciaSuministro: number;
  codigoOficina: number;

  existeBandeja: boolean = false;

  codigoValidacion: string;
  codigoValidacion2: string;
  codigoValidacionWeb: string;
  correoTemporal: string;
  correoTemporal2: string;
  showSuministro = true;
  showInfContacto = true;

  data: any;
  dataSolcitante: any;
  dataInput: any;

  @BlockUI() blockUI: NgBlockUI;
  navigationSubscription;
  flagCodigovalidacion: boolean;
  mobileQuery: MediaQueryList;
  datos: FormGroup;

  toggle: boolean = true;
  flagBoton: boolean = true;
  flagBotonFina: boolean = true;
  flagBotonDato: boolean = false;
  flagBotonDocs: boolean = false;
  flagEnableParent: boolean = false;
  flagEnviar: boolean = true;
  returnDialog: boolean = false;
  disabledActions: boolean = false;
  botonIr: string;
  tiposDocumento = [{ "tipo": "", "descripcion": "<<Seleccione>>" }];
  solicitante: any;
  suministro: number;
  tipo_documento: string;
  numero_documento: string;
  razonsocialrrll: string;
  listaParametro: any[];
  parentescos = [
    {
      id_codigo: '',
      id_subcodigo: '',
      id_usua_crea: null,
      vl_val_parametro: '',
      tx_nom_parametro: '<<Seleccione>>'
    },
  ];
  isTitular: boolean;
  celuValido: boolean;
  telefonoValido: boolean;
  validarCelularSIMPLE: boolean;
  showCheckCelular: boolean;
  tipoValiCell: string;
  validarTelefonoSIMPLE: boolean;
  listaMsjes: any[];
  mailValidoPrincipal: boolean;
  parametrosCorreo: any;
  flagCodigovalidacion1: boolean;
  flagCodigovalidacion2: boolean;
  mailValidoAlternativo: boolean;
  showButton: boolean;
  verDocumentos: boolean;
  checkUno: boolean;
  checkDos: boolean;
  tamanoMaxFile: any;
  tipoPersona: string;
  labelname: string;
  labelapep: string;
  labelapem: string;
  labelmail: string;
  isJuridico: boolean = false;
  textValidacion: string;
  codigoValidacionTelefono: string;
  txtBotonSend: string = "Realizar Afiliación";

  private _mobileQueryListener: () => void;

  constructor(private sanitizer: DomSanitizer,
    private supplyService: SupplyService,
    private router: Router,
    private toastr: ToastrService,
    private financiamientoApiService: FinanciamientoApiService,
    private globals: Globals,
    changeDetectorRef: ChangeDetectorRef,
    public dialog: MatDialog,
    public media: MediaMatcher,
    private solicitanteSevice: SolicitanteApiService,
    private parametrosApiService: ParametroApiService) {
    this.mobileQuery = media.matchMedia("(max-width: 600px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd && this.showSuministro === false) {
        this.showSuministro = true;
        this.ngOnInit();
      }
    });

    this.labelDefecto();

    this.datos = new FormGroup({
      nombres: new FormControl(""),
      paterno: new FormControl(""),
      materno: new FormControl(""),
      tipDocumento: new FormControl(""),
      numDocumento: new FormControl(""),
      parentesco: new FormControl("", Validators.required),
      telefono: new FormControl(""),
      celular: new FormControl("", Validators.required),
      codigoC1: new FormControl(""),
      codigoC2: new FormControl(""),
      codigoC3: new FormControl(""),
      codigoC4: new FormControl(""),
      correo: new FormControl("", [Validators.required, Validators.email]),
      codigo1: new FormControl("", Validators.required),
      codigo2: new FormControl("", Validators.required),
      codigo3: new FormControl("", Validators.required),
      codigo4: new FormControl("", Validators.required),
      correoSecundario: new FormControl("", [Validators.email]),
      codigoS1: new FormControl(""),
      codigoS2: new FormControl(""),
      codigoS3: new FormControl(""),
      codigoS4: new FormControl("")
    });

  }

  get f() {
    return this.datos.controls;
  }

  ngOnInit() {
    this.mailValidoPrincipal = false;
    this.mailValidoAlternativo = false;
    this.validarTelefonoSIMPLE = false;
    this.validarCelularSIMPLE = false;
    this.celuValido = false;
    this.telefonoValido = false;
    this.isTitular = false;
    this.showButton = false;
    this.verDocumentos = false;
    // this.validacionSMS = false;
    this.checkUno = true;
    this.checkDos = true;
    this.disableCamposDefault();
    this.suministro = Number(sessionStorage.getItem('suministro'));
    this.tipo_documento = sessionStorage.getItem('tipoDocumento');
    this.numero_documento = sessionStorage.getItem('numeroDocumento');

    if (
      this.globals.tip_docum === '' ||
      this.globals.suministro === '' ||
      this.globals.num_docum === ''
    ) {
      this.toastr.warning(
        "Se perdió la conexión, vuelva a ingresar para continuar. Datos del solicitante no encontrados",
        "Atención", {
        timeOut: 5000,
      });
      this.router.navigate(['']);
      return;
    }
    // Obtener Tipo Documentos
    this.financiamientoApiService.getTipoDocumentos().subscribe((response) => {
      this.tiposDocumento = this.tiposDocumento.concat(response.resultado);
    });
    this.cargarParentesco();
    this.infoSolicitante(this.suministro, this.tipo_documento, this.numero_documento);
    this.cargarValidacionCelular();
    this.cargarMsjPantalla();
    this.cargarParametrosFile();
    this.disableCamposDefault();
    const body = {
      clase: "VALIDACION CORREOS ARD",
      modulo: "ARD_WEB",
      categoria: ""
    };
    this.parametros(body);
    this.textValidacion = '¿Su(s) Nombre(s) y Apellidos son correctos?';
  }


  async infoSolicitante(suministro: number, tipo_documento: string, numero_documento: string) {
    this.solicitante = {};
    this.celuValido = false;
    this.isJuridico = false;
    await this.solicitanteSevice.datosSolicitante(suministro, tipo_documento, numero_documento).toPromise().then(
      (response: Response) => {
        if (response.estado === 'OK') {
          if (response.resultado) {
            this.solicitante = response.resultado[0];
            this.tipoPersona = this.solicitante.tipoPersona;
            this.datos.controls.parentesco.setValue(this.solicitante.codigoParentesco);
            this.datos.controls.telefono.setValue(this.solicitante.telefono);
            this.datos.controls.celular.setValue(this.solicitante.celular);
            this.datos.controls.nombres.setValue(this.solicitante.nombresnotit);
            this.datos.controls.paterno.setValue(this.solicitante.apepatnotit);
            this.datos.controls.materno.setValue(this.solicitante.apematnotit);
            this.datos.controls.tipDocumento.setValue(this.tipo_documento)
            this.datos.controls.numDocumento.setValue(this.solicitante.numdocnotit)
            this.datos.controls.correo.setValue(this.solicitante.correo.trim());
            this.datos.controls.correoSecundario.setValue(this.solicitante.correoSecundario);
            if (this.datos.controls.parentesco.value === 'RW001') {
              this.isTitular = true;
            } else {
              this.isTitular = false;
            }
            this.cargarDocsParentesco(this.datos.controls.parentesco.value);
            if (this.datos.controls.celular.value && this.datos.controls.celular.value !== '') {
              this.celuValido = !this.celuValido;
            }
            if (this.tipoPersona === 'PS002') {
              this.textValidacion = '¿Su(s) Nombre(s)  de RRLL y Razón Social son correctos?';
              this.isJuridico = true;
              this.globals.isJuridico = true;
              this.labelJuridico();
            }
            if (this.isTitular) {
              this.showInfContacto = false;
            } else {
              this.showInfContacto = true;
            }
          }
        }
      },
      (error) => {
        console.log('Error');
      }
    );
  }

  async cargarParentesco() {
    this.listaParametro = [];
    await this.consultaParametros('5', '');
    this.listaParametro = this.listaParametro.filter(x => x.id_subcodigo !== 0);
    this.parentescos = this.parentescos.concat(this.listaParametro);
  }

  async cargarValidacionCelular() {
    this.listaParametro = [];
    await this.consultaParametros('8', '');
    this.listaParametro = this.listaParametro.filter(x => x.id_subcodigo !== 0);
    const validarSMS = this.listaParametro.find(x => x.vl_val_parametro === '1');
    if (validarSMS.tx_nom_parametro === 'SIMPLE') {
      this.tipoValiCell = 'VT001'; // Simple
    } else {
      this.tipoValiCell = 'VT002'; // SMS
    }
  }

  async cargarMsjPantalla() {
    this.listaParametro = [];
    this.listaMsjes = [];
    await this.consultaParametros('7', '');
    this.listaMsjes = this.listaParametro.filter(x => x.id_subcodigo !== 0);
  }

  async cargarParametrosFile() {
    this.listaParametro = [];
    await this.consultaParametros('4', '');
    this.listaParametro = this.listaParametro.filter(x => x.id_subcodigo !== 0);
    this.tamanoMaxFile = this.listaParametro.find(x => x.id_subcodigo === 1);
    this.limitFile = (Number(this.tamanoMaxFile.vl_val_parametro) / (1024 * 1024));
  }

  async parametros(body: any) {
    await this.financiamientoApiService.getParametrosGc(body).toPromise()
      .then((response) => {
        this.parametrosCorreo = response.resultado;
        //////////////////////////////////////////////////////////
        const body = {
          //>usuario: remitente,
          //usuario: "",
          email: this.datos.value.correo.toString(),
          asunto: this.parametrosCorreo[0].valor,
          rutaLogo: this.parametrosCorreo[1].valor,
          parrafo_01: this.parametrosCorreo[2].valor,
          parrafo_02: this.parametrosCorreo[3].valor,
          remitente: this.parametrosCorreo[4].valor,
          sistema: this.parametrosCorreo[5].valor.toUpperCase()
        };

      });
  }

  buscarDocs() {
    this.dataSource = [];
    // this.labelDefecto();
    // this.datos.controls['razonsocialRRLL'].clearValidators(); // eliminar validacion
    // this.datos.controls['razonsocialRRLL'].updateValueAndValidity(); // actualizar validacion
    const parentescoCod = this.datos.controls.parentesco.value.toString();
    if (this.datos.controls.parentesco.value.toString() === 'RW001' && this.globals.tip_docum.toString() !== 'TD002') {
      this.tipoPersona = 'PS001'; // Persona Natural Titular
    } else if (this.datos.controls.parentesco.value.toString() === 'RW002' && this.globals.tip_docum.toString() !== 'TD002') {
      this.tipoPersona = 'PS001'; // Persona Natural No Titular
    } else if (this.datos.controls.parentesco.value.toString() === 'RW004' && this.globals.tip_docum.toString() !== 'TD002') {
      this.tipoPersona = 'PS001'; // Persona Natural No Titular
    } else if (this.datos.controls.parentesco.value.toString() === 'RW003' && this.globals.tip_docum.toString() == 'TD002') {
      this.tipoPersona = 'PS001'; // Persona Natural No Titular
    } else if (this.datos.controls.parentesco.value.toString() === 'RW001' && this.globals.tip_docum.toString() == 'TD002') {
      // this.labelJuridico(); // Persona Juridica
      this.tipoPersona = 'PS002';
      this.datos.get('razonsocialRRLL').setValidators(Validators.required); // agregar validacion
      this.datos.controls['razonsocialRRLL'].updateValueAndValidity(); // actualizar validacion
    }
    this.cargarDocsParentesco(parentescoCod);
  }

  mostrarDialogo(event: any): void {
    this.dialog
      .open(DialogoConfirmacionComponent, {
        data: `¿Desea eliminar el documento seleccionado?`
      })
      .afterClosed()
      .subscribe((confirmado: Boolean) => {
        if (confirmado) {
          this.filesMap.delete(event.id);
          event.docAdjunto = "";
          event.tieneDocumento = false;
        }
      });
  }

  disableDocumentos() {
    if (this.dataSource) {
      this.dataSource.forEach(function (value) {
        value.tieneDocumento = true;    //if working
        value.disabledAdjuntar = true;  //no work
        value.disabledEliminar = true;  //no work
      });
      this.disabledActions = true;
    }
  }

  enabledDocumentos() {
    this.dataSource.forEach(function (value) {
      value.tieneDocumento = false;    //if working
      value.disabledAdjuntar = false;  //no work
      value.disabledEliminar = false;  //no work
    });
    this.disabledActions = false;
  }

  async verEvent(event: any) {
    if (this.existeBandeja && event.estadoDocumento === "DC002") {
      const body = {
        nombreAchivo: event.docAdjunto
      };
      this.financiamientoApiService
        .getDescargarArchivo(body)
        .toPromise()
        .then((response) => {
          if (response.resultado.flag) {
            let nombreArchivo = response.resultado.fileName;
            let extensionArchivo = nombreArchivo.split(".").pop();
            if (extensionArchivo && extensionArchivo === 'pdf') {
              const dialogRef = this.dialog.open(VisorDocumentosComponent, {
                data: {
                  src: `data:application/pdf;base64,${response.resultado.fileBase64}`,
                  nombre: response.resultado.fileName,
                  tipo: 'application/pdf',
                },
              });

            } else {
              const dialogRef = this.dialog.open(VisorDocumentosComponent, {
                data: {
                  src: `data:image/jpeg;base64,${response.resultado.fileBase64}`,
                  nombre: response.resultado.fileName,
                  tipo: 'image/jpeg',
                },
              });
            }
          } else {
            this.toastr.error("No se encontró el archivo adjunto en la carpeta compartida.", "Atención", {
              closeButton: true,
            });
          }
        }).catch(error => {
          console.log(error);
        });
    } else {
      let file = this.filesMap.get(event.id).file;
      const dialogRef = this.dialog.open(VisorDocumentosComponent, {
        data: {
          src: await this.getBase64(file),
          nombre: file.name,
          tipo: file.type,
        },
      });
    }
  }

  async getBase64(file: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });
  }

  cambiarNombreArchivo(filename: string) {
    let tipoExtension: string;
    let nroSuministro: string = "0";
    let tipDocumento: string;
    let nroDocumento: string;

    if (filename && filename.length > 0) {
      tipoExtension = filename.split(".").pop();
      nroSuministro = this.globals.suministro.toString();
      tipDocumento = this.globals.tip_docum.toString()
      nroDocumento = this.globals.num_docum.toString();
      let j = 0;
      this.dataSource.forEach(function (value) {
        let nombreArchivo: string = "";
        const tipoDocuDNI = "TD001";
        if (tipoDocuDNI == tipDocumento) {
          nombreArchivo = nroSuministro + "_" + (j + 1) + "." + tipoExtension;
        } else {
          nombreArchivo = nroSuministro + "_" + nroDocumento + (j + 1) + "." + tipoExtension;
        }
        value.docAdjunto = nombreArchivo;
        j++;
      });
    }
  }

  adjuntarEvent(event: any) {
    let totalSize = 0;
    this.filesMap.forEach((value: any, key: any) => {
      totalSize += value.file.size;
    });
    totalSize += event.file.size;
    if (totalSize > this.tamanoMaxFile.vl_val_parametro) {
      const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 23);
      this.mensajeWarning(mensaje.vl_val_parametro + " (" + this.limitFile + " MB)");
      return;
    }
    this.filesMap.set(event.item.id, { file: event.file, item: event.item });
    let item = this.dataSource.find((x) => x.id === event.item.id);
    let factor: number = 1048576;

    if (item) {
      item.docAdjunto = this.getFileChanged(item.id, event.file.name);
      item.tieneDocumento = true;
      let capacidad: number = parseInt(event.file.size) / factor;

      item.size = capacidad.toFixed(2);
      item.tipoExt = event.file.type === 'image/jpeg' ? 'jpg' : 'pdf';
    }
  }

  eliminarEvent(event: any) {
    this.mostrarDialogo(event);
  }

  getFileChanged(j: number, filename: string) {
    let returned: string = "";
    let tipoExtension: string;
    let nroSuministro: string = "0";
    let nroDocumento: string;
    let nombreArchivo: string = "";
    const tipoDocuDNI = "TD001";
    tipoExtension = filename.split(".").pop();
    nroSuministro = this.globals.suministro.toString();
    nroDocumento = this.globals.num_docum.toString();

    returned = nroSuministro + "_" + nroDocumento + "_" + (j) + "." + tipoExtension;
    return returned;
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  //Focos para los codigos 1-4
  processKeyUp(e, el) {
    el.focus();
  }

  processKeyUpCelular(e, element) {
    element.focus();
  }

  validacionCorreoFinal() {
    this.codigoValidacionWeb =
      this.datos.controls.codigo1.value.toString() +
      this.datos.controls.codigo2.value.toString() +
      this.datos.controls.codigo3.value.toString() +
      this.datos.controls.codigo4.value.toString();

    this.flagCodigovalidacion1 = false;
    if (this.datos.controls.correo.value.toString() == this.correoTemporal) {
      if (this.codigoValidacionWeb == this.codigoValidacion) {
        this.flagCodigovalidacion1 = true;
        this.flagEnviar = false;
        this.toggle = false;
        this.deshabilitarInputsCorreo();
        // this.toastr.success("Validación de correo satisfactoria.", "Atención", {closeButton: true,});
      } else {
        this.flagEnviar = true;
        this.toggle = true;
        this.datos["controls"]["codigo1"].setValue("");
        this.datos["controls"]["codigo2"].setValue("");
        this.datos["controls"]["codigo3"].setValue("");
        this.datos["controls"]["codigo4"].setValue("");
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 16);
        this.mensajeWarning(mensaje.vl_val_parametro);
      }
    } else {
      this.flagCodigovalidacion1 = false;
      this.flagEnviar = true;
      this.toggle = true;
      this.datos["controls"]["codigo1"].setValue("");
      this.datos["controls"]["codigo2"].setValue("");
      this.datos["controls"]["codigo3"].setValue("");
      this.datos["controls"]["codigo4"].setValue("");
      this.toastr.warning(
        "El correo ha variado. Debe validar nuevamente",
        "Atención",
        { closeButton: true }
      );
      return;
    }
  }

  opcionSi() {
    this.datoSolCorrecto = 1;
    this.showButton = false;
    this.verDocumentos = false;
    this.flagBotonFina = true;
    this.flagBotonDato = false;
    this.txtBotonSend = "Realizar Afiliación"
  }

  opcionNo() {
    this.datoSolCorrecto = 2;
    this.showButton = true;
    this.verDocumentos = true;
    this.flagBotonFina = false;
    this.flagBotonDato = true;
    this.txtBotonSend = "Enviar"

    this.cargarDocsParentesco(this.datos.controls.parentesco.value);
  }

  validaCorreo() {
    if (this.mailValidoPrincipal) {

      (<any>Object).values(this.datos.controls).forEach((control) => {
        control.markAsTouched();
      });
      this.correoTemporal = this.datos.value.correo.toString();

      let camposValidados: boolean = true;
      if (this.datos.controls.parentesco.value.toString() === 'FW001' && this.globals.tip_docum.toString() == 'TD002') {
        if (this.datos.controls.parentesco.value != "" &&
          this.datos.controls.parentesco.value != undefined &&
          this.datos.controls.correo.value != "" &&
          this.datos.controls.correo.value != undefined &&
          this.datos.controls.razonsocialRRLL.value != "" &&
          this.datos.controls.razonsocialRRLL.value != undefined) {
          camposValidados = true;
        } else {
          camposValidados = false;
        }

      } else {
        if (this.datos.controls.parentesco.value != "" &&
          this.datos.controls.parentesco.value != undefined &&
          this.datos.controls.correo.value != "" &&
          this.datos.controls.correo.value != undefined) {
          camposValidados = true;
        } else {
          camposValidados = false;
        }

      }
      if (camposValidados) {
        let remitente = this.solicitante.nombres + " " + this.solicitante.paterno + " " + this.solicitante.materno + ".";

        const body = {
          usuario: remitente,
          //usuario: "",
          email: this.datos.value.correo.toString(),

          asunto: this.parametrosCorreo[0].valor,
          rutaLogo: this.parametrosCorreo[1].valor,
          parrafo_01: this.parametrosCorreo[2].valor,
          parrafo_02: this.parametrosCorreo[3].valor,
          remitente: this.parametrosCorreo[4].valor,
          sistema: this.parametrosCorreo[5].valor.toUpperCase()

        };
        //Obtener Codigo de verificacion
        this.codigoValidacion = "";
        this.supplyService.validarCorreo(body).subscribe((response) => {
          this.codigoValidacion = response.bRESP.data.codigoVerificacion;
          if (this.codigoValidacion.length) {
            this.habilitarInputsMailPrincipal();
            const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 15);
            this.mensajeInfo(mensaje.vl_val_parametro);
          } else {
            this.mensajeWarning('Servicio de validación de correo no esta disponible, Verifique con su administrador!');
          }
        });
      } else {
        this.toastr.warning("Los campos Nombres, Apellidos y Correo Electrónico son necesarios para la notificación de correo", "Atención", { closeButton: true });
        return;
      }
    }
  }


  validaCorreoSecundario() {
    if (this.mailValidoAlternativo) {
      /* (<any>Object).values(this.datos.controls).forEach((control) => {
         control.markAsTouched();
       });*/
      this.correoTemporal2 = this.datos.value.correoSecundario.toString();
      let camposValidados: boolean = true;

      if (
        this.datos.value.correoSecundario != "" &&
        this.datos.value.correoSecundario != undefined) {
        if (this.datos.controls.correo.value === this.datos.value.correoSecundario.trim()) {
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 25);
          this.mensajeWarning(mensaje.vl_val_parametro);
          return;
        } else {
          camposValidados = true;
        }
      } else {
        camposValidados = false;
      }
      if (camposValidados) {
        let remitente = this.solicitante.nombres + " " + this.solicitante.paterno + " " + this.solicitante.materno + ".";
        //let remitente = this.datos.value.nombres + ", " + this.datos.value.paterno + " " + this.datos.value.materno;

        const body = {
          usuario: remitente,
          //usuario: "",
          email: this.datos.value.correoSecundario.toString(),

          asunto: this.parametrosCorreo[0].valor,
          rutaLogo: this.parametrosCorreo[1].valor,
          parrafo_01: this.parametrosCorreo[2].valor,
          parrafo_02: this.parametrosCorreo[3].valor,
          remitente: this.parametrosCorreo[4].valor,
          sistema: this.parametrosCorreo[5].valor.toUpperCase()

        };

        //Obtener Codigo de verificacion
        this.codigoValidacion2 = "";
        this.supplyService.validarCorreo(body).subscribe((response) => {

          this.codigoValidacion2 = response.bRESP.data.codigoVerificacion;
          if (this.codigoValidacion2.length) {
            this.habilitarInputsMailAlternativo();
            const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 15);
            this.mensajeInfo(mensaje.vl_val_parametro);
          } else {
            this.mensajeWarning('Servicio de validación de correo no esta disponible, Verifique con su administrador!');
          }
        });

      } else {
        this.toastr.warning("Los campos Nombres, Apellidos y Correo Electrónico son necesarios para la notificación de correo", "Atención", { closeButton: true });
        return;
      }
    }
  }


  validacionCorreoSecundarioFinal() {
    this.codigoValidacionWeb =
      this.datos.value.codigoS1.toString() +
      this.datos.value.codigoS2.toString() +
      this.datos.value.codigoS3.toString() +
      this.datos.value.codigoS4.toString();

    this.flagCodigovalidacion2 = false;
    if (this.datos.value.correoSecundario.toString() == this.correoTemporal2) {
      if (this.codigoValidacionWeb == this.codigoValidacion2) {
        this.flagCodigovalidacion2 = true;
        this.flagEnviar = false;
        this.toggle = false;
        this.deshabilitarInputsCorreoSecundario();
        // this.toastr.success("Validación de correo satisfactoria.", "Atención", {closeButton: true,});
      } else {
        this.flagEnviar = true;
        this.toggle = true;
        this.datos["controls"]["codigoS1"].setValue("");
        this.datos["controls"]["codigoS2"].setValue("");
        this.datos["controls"]["codigoS3"].setValue("");
        this.datos["controls"]["codigoS4"].setValue("");
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 16);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return;
      }
    } else {
      this.flagCodigovalidacion2 = false;
      this.flagEnviar = true;
      this.toggle = true;
      this.datos["controls"]["codigoS1"].setValue("");
      this.datos["controls"]["codigoS2"].setValue("");
      this.datos["controls"]["codigoS3"].setValue("");
      this.datos["controls"]["codigoS4"].setValue("");
      this.toastr.warning(
        "El correo ha variado. Debe validar nuevamente",
        "Atención",
        { closeButton: true }
      );
      return;
    }
  }


  deshabilitarInputsCorreoSecundario() {
    this.datos.controls['correoSecundario'].disable();
    this.datos.controls["codigoS1"].disable();
    this.datos.controls["codigoS2"].disable();
    this.datos.controls["codigoS3"].disable();
    this.datos.controls["codigoS4"].disable();
  }

  stripCorreo(tipoMail: any) {
    let email = '';
    if (tipoMail === 1) {
      this.mailValidoPrincipal = false;
      email = this.datos.controls.correo.value;
    } else if (tipoMail === 2) {
      this.mailValidoAlternativo = false;
      email = this.datos.value.correoSecundario;
    }

    const EMAIL_REGEX = /^[a-z]+[a-z0-9._-]+@[a-z]+\.[a-z.]{2,5}$/;//  /^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/; // /^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,5}$/;

    if (EMAIL_REGEX.test(email.trim())) {
      if (tipoMail === 1) {
        this.mailValidoPrincipal = true;
        this.flagCodigovalidacion1 = false;
        this.datos["controls"]["codigo1"].setValue("");
        this.datos["controls"]["codigo2"].setValue("");
        this.datos["controls"]["codigo3"].setValue("");
        this.datos["controls"]["codigo4"].setValue("");
      } else if (tipoMail === 2) {
        this.mailValidoAlternativo = true;
        this.flagCodigovalidacion2 = false;
        this.datos["controls"]["codigoS1"].setValue("");
        this.datos["controls"]["codigoS2"].setValue("");
        this.datos["controls"]["codigoS3"].setValue("");
        this.datos["controls"]["codigoS4"].setValue("");
      }
    }
    if (tipoMail === 1) {
      if (!this.mailValidoPrincipal) {
        if (email != "" && email != undefined) {
          this.blockUI.stop();
          this.mailValidoPrincipal = false;
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 14);
          this.mensajeWarning(mensaje.vl_val_parametro);
          return;
        } else {
          this.blockUI.stop();
          this.mailValidoPrincipal = false;
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 13);
          this.mensajeWarning(mensaje.vl_val_parametro);
          return;
        }
      }
    } else if (tipoMail === 2) {
      if (!this.mailValidoAlternativo && email.trim() != "") {
        this.blockUI.stop();
        this.mailValidoAlternativo = false;
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 24);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return;
      } else {
        if (this.datos.value.correo.trim() == this.datos.value.correoSecundario.trim()) {
          this.blockUI.stop();
          this.mailValidoAlternativo = false;
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 25);
          this.mensajeWarning(mensaje.vl_val_parametro);
          return;

        }
      }
    }
  }

  habilitarInputsMailAlternativo() {
    this.datos.controls['codigoS1'].enable();
    this.datos.controls['codigoS2'].enable();
    this.datos.controls['codigoS3'].enable();
    this.datos.controls['codigoS4'].enable();
  }


  stripCelular() {
    this.celuValido = false;
    let celularValido = false;
    this.validarCelularSIMPLE = false;
    let celular = this.datos.controls.celular.value;
    let CELULAR_REGEX = /^[0-9]{9}$/;
    celular = String(celular);

    if (celular.match(CELULAR_REGEX)) {
      celularValido = true;
      this.celuValido = true;
      this.validarCelularSIMPLE = true;
    }
    if (!celularValido && celular.toString() != "") {
      this.blockUI.stop();
      const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 18);
      this.mensajeWarning(mensaje.vl_val_parametro);
      return;
    } else {

      let strCelular = celular.toString();
      if (strCelular == "" || strCelular == undefined) {

        this.blockUI.stop();
        this.celuValido = false;
        this.validarCelularSIMPLE = false;
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 17);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return;

      } else {
        let primerNumero = strCelular.substring(0, 1);

        if (primerNumero != '9') {
          this.blockUI.stop();
          this.celuValido = false;
          this.validarCelularSIMPLE = false;
          const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 19);
          this.mensajeWarning(mensaje.vl_val_parametro);
          return;
        }

        //this.stripTelefono();
        /*comentado por validacion redundante con los focus*/
      }
    }
  }

  validaCelular() {
    //this.stripCelular();
    if (this.datos.controls.celular.value.substring(0, 1) !== '9') {
      /*
      const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 19);
      this.mensajeWarning(mensaje.vl_val_parametro);*/
      console.info("stripCelular");
      return;
    }
    this.showCheckCelular = false;
    if (this.tipoValiCell === 'VT001') {
      /*Se añade logica para validacion cuando se recuperan datos del backend */
      this.celuValido = false;
      let celularValido = false;
      this.validarCelularSIMPLE = false;
      let celular = this.datos.controls.celular.value;
      let CELULAR_REGEX = /^[0-9]{9}$/;
      celular = String(celular);
      if (celular.match(CELULAR_REGEX)) {
        celularValido = true;
        this.celuValido = true;
        this.validarCelularSIMPLE = true;
      }

      let telefono = this.datos.value.telefono;
      if (!telefono || telefono.length === 0) {
        this.validarTelefonoSIMPLE = true;
        this.telefonoValido = true;
      } else if (telefono.length === 7) {
        this.validarTelefonoSIMPLE = true;
        this.telefonoValido = true;
      }
      /*Fin de validacion */
      if (this.validarCelularSIMPLE || this.validarTelefonoSIMPLE) {
        if (this.telefonoValido && this.celuValido) {
          this.showCheckCelular = true;
          this.deshabilitarInputsTelefonos();
        }
      }
    } else {

      if (this.datos.value.celular != "" && this.datos.value.celular != undefined) {
        const body = {
          celular: this.datos.value.celular.toString()
        };

        //Obtener Codigo de verificacion
        this.codigoValidacionTelefono = "";
        this.supplyService.validarCelular(body).subscribe((response) => {

          this.codigoValidacionTelefono = response;
          if (this.codigoValidacionTelefono != "" && this.codigoValidacionTelefono != undefined) {
            this.habilitarInputsCelular();
            const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 21);
            this.mensajeInfo(mensaje.vl_val_parametro);
          } else {
            this.mensajeWarning('Servicio de validación de celular no esta disponible, Verifique con su administrador!');
          }
        });

      }
    }
  }

  validacionCelular() {
    let codigoValidacionCelular =
      this.datos.value.codigoC1.toString() +
      this.datos.value.codigoC2.toString() +
      this.datos.value.codigoC3.toString() +
      this.datos.value.codigoC4.toString();

    if (codigoValidacionCelular == this.codigoValidacionTelefono) {
      this.showCheckCelular = true;
      this.deshabilitarInputsTelefonos();


    } else {
      this.flagEnviar = true;
      this.toggle = true;
      const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 22);
      this.mensajeWarning(mensaje.vl_val_parametro);
      this.datos["controls"]["codigoC1"].setValue("");
      this.datos["controls"]["codigoC2"].setValue("");
      this.datos["controls"]["codigoC3"].setValue("");
      this.datos["controls"]["codigoC4"].setValue("");
    }

  }

  stripText(control: FormControl) {
    control.setValue(control.value.replace(/[^0-9]/g, ''));
  }

  stripTelefono() {
    let telefono = this.datos.value.telefono;
    this.validarTelefonoSIMPLE = true;
    if (telefono != "" && telefono.length != 7) {
      this.validarTelefonoSIMPLE = false;
      this.telefonoValido = false;
      this.blockUI.stop();
      const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 20);
      this.mensajeWarning(mensaje.vl_val_parametro);
      return;
    } else {
      if (this.validarCelularSIMPLE) {
        this.telefonoValido = true;
      } else {
        this.telefonoValido = false;
      }
    }

  }

  validForm() {
    (<any>Object).values(this.datos.controls).forEach((control) => {
      control.markAsTouched();
    });
    //if (this.datos.invalid) {
    if (!this.isTitular) {
      if (this.solicitante.nombres === '' || this.solicitante.nombres === null || this.solicitante.nombres === undefined) {
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 33);
        this.mensajeWarning(mensaje.vl_val_parametro);
      }
      if (this.solicitante.paterno === '' || this.solicitante.paterno === null || this.solicitante.paterno === undefined) {
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 34);
        this.mensajeWarning(mensaje.vl_val_parametro);
      }
      if (this.solicitante.materno === '' || this.solicitante.materno === null || this.solicitante.materno === undefined) {
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 35);
        this.mensajeWarning(mensaje.vl_val_parametro);
      }
    }
    if (this.datos.controls.celular.value) {
      if (this.datos.controls.celular.value.length < 9) {
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 18);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return false;
      }
    } else {
      const celular = this.datos.controls.celular.value;
      if (celular === '' || celular === null || celular === undefined) {
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 17);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return false;
      }
    }
    if (this.datos.controls.telefono.value) {
      //se comenta para evitar doble validacion, una del input text y otra del submit
      /*
      const telefono = this.datos.controls.telefono.value.trim();
      if (telefono.length < 7) {
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 20);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return false;
      }*/
    }

    //se comenta para evitar doble validacion, una del input text y otra del submit
    /*
    if (this.datos.controls.correo.value) {      
      const EMAIL_REGEX = /^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
      if (!EMAIL_REGEX.test(this.datos.controls.correo.value.trim())) {
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 14);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return false;
      }
    } else {
      const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 13);
      this.mensajeWarning(mensaje.vl_val_parametro);
      return false;
    }
    */
    //return false;
    //}
    return true;

  }

  validData() {
    if (!this.celuValido) {
      if (this.datos.controls.celular.value.substring(0, 1) !== '9') {
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 19);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return false;
      } else if (this.datos.controls.celular.value.length < 9) {
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 9);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return false;
      }
    }
    //comentado para no duplicar alerta de validacion
    /*
    if (!this.mailValidoPrincipal) {
      const EMAIL_REGEX = /^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
      if (!EMAIL_REGEX.test(this.datos.controls.correo.value.trim())) {        
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 14);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return false;
      }
      const correo = this.datos.controls.correo.value;
      if (correo === '' || correo === null || correo === undefined) {
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 13);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return false;
      }
    }*/

    if (!this.isTitular) {
      if (this.datos.controls.nombres.value === '' || this.datos.controls.nombres.value === null || this.datos.controls.nombres.value === undefined) {
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 33);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return false;
      }
      if (this.datos.controls.paterno.value === '' || this.datos.controls.paterno.value === null || this.datos.controls.paterno.value === undefined) {
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 34);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return false;
      }
      if (this.datos.controls.materno.value === '' || this.datos.controls.materno.value === null || this.datos.controls.materno.value === undefined) {
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 35);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return false;
      }
    }

    // Validar documentos
    /*
    if (this.dataSource) {
      for (let index = 0; index < this.dataSource.length; index++) {
        if (
          this.dataSource[index].tieneDocumento === null ||
          this.dataSource[index].tieneDocumento === undefined
        ) {
          this.toastr.warning(
            "Adjunte todos los documentos solicitados",
            "Atención",
            { closeButton: true }
          );
          return false;
        }
      }
    } else {
      this.toastr.warning(
        "Adjunte todos los documentos solicitados",
        "Atención",
        { closeButton: true }
      );
      return false;

    }
    */

    if (this.showButton) {

      const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 43);

      for (let index = 0; index < this.dataSource.length; index++) {
        if (this.dataSource[index].docAdjunto === null || this.dataSource[index].docAdjunto === undefined) {

          this.toastr.warning(
            mensaje.vl_val_parametro,
            //"Por lo menos uno de los archivos adjuntos ha excedido el tamaño máximo permitido",
            "Atención",
            { closeButton: true }
          );
          return false;
        } else {
          let strDocAdjunto = this.dataSource[index].docAdjunto;
          strDocAdjunto = strDocAdjunto.replace(/\s/g, "");
          if (strDocAdjunto.length == 0) {
            this.toastr.warning(
              mensaje.vl_val_parametro,
              //"Por lo menos uno de los archivos adjuntos ha excedido el tamaño máximo permitido",
              "Atención",
              { closeButton: true }
            );
            return false;
          }
        }

      }
    }

    if (this.showButton) {
      if (this.dataSource) {
        for (let index = 0; index < this.dataSource.length; index++) {
          if (this.dataSource[index].docAdjunto === null || this.dataSource[index].docAdjunto === undefined) {
            this.toastr.warning(
              "Adjunte todos los documentos solicitados",
              "Atención",
              { closeButton: true }
            );
            return false;
          } else {
            let strDocAdjunto = this.dataSource[index].docAdjunto;
            strDocAdjunto = strDocAdjunto.replace(/\s/g, "");
            if (strDocAdjunto.length == 0) {
              this.toastr.warning(
                "Adjunte todos los documentos solicitados",
                "Atención",
                { closeButton: true }
              );
              return false;
            }
          }
        }
      }
    }

    // Validar que no excede la capacidad limite de los archivos
    let flagExcedido: boolean = false;
    let factor: number = 1048576;
    //let capacidad:number = 10485760;
    let capacidad: number = factor * this.limitFile;


    this.sizeFile = 0;
    this.filesMap.forEach((value: any) => {
      //this.sizeFile = this.sizeFile + value.file.size;
      this.sizeFile = value.file.size;
      if (capacidad < this.sizeFile) {
        flagExcedido = true;
      }
    });
    console.log("size", this.sizeFile);
    console.log("flagExcedido", flagExcedido);

    if (flagExcedido) {
      this.toastr.warning(
        //"Documentos adjuntos excedieron el limite máximo!",
        "Por lo menos uno de los archivos adjuntos ha excedido el tamaño máximo permitido",
        "Atención",
        { closeButton: true }
      );
      return false;
    }


    if (!this.showCheckCelular) {

      const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 41);
      this.mensajeWarning(mensaje.vl_val_parametro);
      return false;

    }

    if (!this.flagCodigovalidacion1) {

      const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 63);
      this.mensajeWarning(mensaje.vl_val_parametro);
      return false;
    }

    if (this.datos.value.correoSecundario && this.mailValidoAlternativo) {
      if (!this.flagCodigovalidacion2 && this.isJuridico) {
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 42);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return false;
      }
    }

    return true;
  }

  getFileName(j: number, file: any, formValue: any) {
    let returned: string = '';
    //let nroSuministro = formValue.suministro;
    let nroSuministro = this.solicitante.suministro;
    //let nroDocumento = formValue.numDocumento;
    let nroDocumento = this.solicitante.numeDocumento;
    let tipoExt = file.type === 'image/jpeg' ? 'jpg' : 'pdf';
    returned = nroSuministro + "_" + nroDocumento + "_" + (j + 1) + "." + tipoExt;

    return returned;
  }

  async submit() {
    if (this.validForm() && this.validData()) {
      if (!this.checkUno) {
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 44);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return;
      }
      let formValue = this.datos.getRawValue();
      this.data = JSON.parse(sessionStorage.getItem('dataRegistro'));
      let secuenciaSuministro: any = this.data.secusuministro;
      let codigoOficina: any = this.data.codioficina;
      let docAdjuntos: any = [];
      let j = 0;
      let totalSize = 0;
      this.filesMap.forEach((value: any, key: any) => {
        docAdjuntos.push({
          idBandeja: 0,
          tipoDocArchivo: value.item.tipo,
          nombreArchivo: this.getFileName(j, value.file, formValue),
          estadoDocumento: "DC001",////valor anterior: 'DW001'
          motivoRechazo: ' ',
          size: value.item.size,
          tipoExt: value.item.tipoExt
        });
        totalSize += value.file.size;
        j++;
      });
      /*if (totalSize > this.tamanoMaxFile.vl_val_parametro) {
        const mensaje = this.listaMsjes.find(x => x.id_codigo === 7 && x.id_subcodigo === 12);
        this.mensajeWarning(mensaje.vl_val_parametro);
        return;
      }*/

      formValue.telefono = formValue.telefono.replace(/\s/g, "");
      formValue.correo = formValue.correo.replace(/\s/g, "");

      if (formValue.telefono && formValue.telefono.length == 0) {
        formValue.telefono = "";
      }

      let nombres = this.solicitante.nombres;
      let paterno = this.solicitante.paterno;
      let materno = this.solicitante.materno;
      let nrodocumento = this.solicitante.numeDocumento;
      if (!this.isTitular) {
        nombres = this.datos.controls.nombres.value;
        paterno = this.datos.controls.paterno.value;
        materno = this.datos.controls.materno.value;
        nrodocumento = this.datos.controls.numDocumento.value;
      }

      let formData: FormData = new FormData();
      formData.append("suministro", this.suministro.toString());
      formData.append("secuenciaSuministro", secuenciaSuministro);
      formData.append("codigoOficina", codigoOficina);
      formData.append("codigoParentesco", formValue.parentesco);
      formData.append("paterno", paterno ? paterno : ' ');
      formData.append("materno", materno ? materno : ' ');
      formData.append("nombres", nombres ? nombres : ' ');
      formData.append("razonsocialRRLL", this.solicitante.razonsocialrrll ? this.solicitante.razonsocialrrll : ' ');
      formData.append("tipoDocumento", this.tipo_documento);
      formData.append("numDocumento", nrodocumento);
      formData.append("telefono", formValue.telefono ? formValue.telefono : 0);
      formData.append("celular", formValue.celular);
      formData.append("correo", formValue.correo);
      formData.append("correoSecundario", formValue.correoSecundario ? formValue.correoSecundario : ' ');
      formData.append("estadoSolicitud", "SO002");//valor anterior: SO001
      formData.append("motiEstadoSolic", "MS002");
      formData.append("docAdjuntos", JSON.stringify(docAdjuntos));
      formData.append("tipoTramite", 'WT003');
      formData.append("estadoTramite", this.showButton ? 'TR001' : 'TR003');//valor anterior:'AR001' : 'AR003'
      formData.append("validacionTelefono", this.tipoValiCell); //VT001 Simple VT002 SMS
      formData.append("tipoCliente", 'AW002');//AW001 Cliente Nuevo AW002 Existente
      formData.append("tipoPersona", this.tipoPersona);//PS001 Natural PS002 Juridica
      formData.append("declajurada ", this.checkUno ? '1' : '0');// true 1 false 0
      formData.append("uso_dat_promocion", this.checkDos ? '1' : '0');// true 1 false 0
      formData.append("nombreValidos", this.showButton ? '0' : '1');// NO 0 SI 1

      this.filesMap.forEach((value: any) => {
        formData.append("document", value.file, value.file.name);
      });
      await this.financiamientoApiService.actualizaSolicitante(formData).toPromise().then(
        (response: Response) => {
          if (response.estado === "OK") {
            if (response.resultado === 0) {
              sessionStorage.setItem('registroCompleto', "1");
              if (this.tipoPersona === 'PS002') {
                //RESPUESTA PERSONA JURIDICA PS002
                if (this.showButton) {
                  //OPCION NO
                  this.globals.tipo_form_solicitante = 4;
                  sessionStorage.setItem('disabledMenu', '1');
                  this.router.navigate(['mensaje-financiamiento']);
                } else {
                  //OPCION SI
                  this.globals.tipo_form_solicitante = 5;
                  this.globals.mailPrincipal = formValue.correo;
                  sessionStorage.setItem('disabledMenu', '1');
                  this.router.navigate(['mensaje-financiamiento']);
                }

              } else {
                //RESPUESTA PERSONA NATURAL PS001
                if (this.showButton) {
                  //OPCION NO
                  this.globals.tipo_form_solicitante = 2;
                  sessionStorage.setItem('disabledMenu', '1');
                  this.router.navigate(['mensaje-financiamiento']);
                } else {
                  //OPCION SI
                  this.globals.tipo_form_solicitante = 3;
                  this.globals.mailPrincipal = formValue.correo;
                  sessionStorage.setItem('disabledMenu', '1');
                  this.router.navigate(['mensaje-financiamiento']);
                }
              }
            }
          }
        },
        (error) => {
          console.log("Error: " + error);
        });
    }
  }

  async consultaParametros(codigo: string, subcodigo: string) {
    await this.parametrosApiService.consultarParametro(codigo, subcodigo).toPromise().then(
      (response: Response) => {
        if (response.estado === 'OK') {
          if (response.resultado) {
            this.listaParametro = response.resultado;
          }
        }
      },
      (error) => {

      }
    );
  }

  mensajeWarning(mensaje: string) {
    this.toastr.warning(mensaje, "Advertencia", { closeButton: true, });
  }
  mensajeInfo(mensaje: string) {
    this.toastr.info(mensaje, "Información", { closeButton: true, });
  }

  deshabilitarInputsTelefonos() {
    this.datos.controls['celular'].disable();
    this.datos.controls['telefono'].disable();
    this.datos.controls["codigoC1"].disable();
    this.datos.controls["codigoC2"].disable();
    this.datos.controls["codigoC3"].disable();
    this.datos.controls["codigoC4"].disable();
  }

  deshabilitarInputsCorreo() {
    this.datos.controls['correo'].disable();
    this.datos.controls["codigo1"].disable();
    this.datos.controls["codigo2"].disable();
    this.datos.controls["codigo3"].disable();
    this.datos.controls["codigo4"].disable();
  }

  disableCamposDefault() {
    this.datos.controls['codigo1'].disable();
    this.datos.controls['codigo2'].disable();
    this.datos.controls['codigo3'].disable();
    this.datos.controls['codigo4'].disable();
    this.datos.controls['codigoS1'].disable();
    this.datos.controls['codigoS2'].disable();
    this.datos.controls['codigoS3'].disable();
    this.datos.controls['codigoS4'].disable();
    this.datos.controls['codigoC1'].disable();
    this.datos.controls['codigoC2'].disable();
    this.datos.controls['codigoC3'].disable();
    this.datos.controls['codigoC4'].disable();
  }

  habilitarInputsMailPrincipal() {
    this.datos.controls['codigo1'].enable();
    this.datos.controls['codigo2'].enable();
    this.datos.controls['codigo3'].enable();
    this.datos.controls['codigo4'].enable();
  }

  habilitarInputsCelular() {
    this.datos.controls['codigoC1'].enable();
    this.datos.controls['codigoC2'].enable();
    this.datos.controls['codigoC3'].enable();
    this.datos.controls['codigoC4'].enable();
  }

  verCheckUno(event: any) {
    this.checkUno = event;
  }

  verCheckDos(event: any) {
    this.checkDos = event;
  }

  /*
  async cargarDocsParentesco(body: string) {
    ...
     await this.consultaParametros('6', '');
     ...
  }
  */
  async cargarDocsParentesco(body: string) {
    //body = codigo de parentesco ejemplo RW001
    const listaParentesco = this.parentescos;
    this.listaParametro = [];

    let datasource: {
      descTipo: string,
      disabledAdjuntar: boolean,
      disabledEliminar: boolean,
      docAdjunto: string,
      estadoDocumento: string,
      flagDocumentHabilitado: boolean,
      id: number,
      idBandeja: number,
      idBandejaDoc: number,
      motivoRechazo: string,
      tieneDocumento: boolean,
      tipo: string
    }[] = [];

    await this.consultaParametros('6', '');
    //console.log('this.listaParametro '+JSON.stringify(this.listaParametro));
    this.listaParametro = this.listaParametro.filter(x => x.id_subcodigo !== 0);

    const parentesco = listaParentesco.find(x => x.vl_val_parametro === body);

    if (parentesco.id_subcodigo != "" && parentesco.id_subcodigo !== undefined) {
      console.log('parentesco.id_subcodigo-->' + parentesco.id_subcodigo);
      const documentos = this.listaParametro.filter(x => x.tx_nom_parametro.toString() === parentesco.id_subcodigo.toString());

      let estadoDoc = '';
      if (this.showButton) {
        estadoDoc = 'DW001';
      } else {
        estadoDoc = 'DW002';
      }
      for (let i = 0; i < documentos.length; i++) {
        /*let tipoDoc = '';
        if(documentos[i].vl_val_parametro == 'Documento que acredite propiedad'){
          tipoDoc = 'AW001';
        }else if(documentos[i].vl_val_parametro == 'Documento de Identidad Persona Natural y Ficha RUC para Persona Juridica (para verificar datos)'){
          tipoDoc = 'AW002';
        }else if(documentos[i].vl_val_parametro == 'Carta poder simple, adjuntando los documentos asignados al poderdante. En caso de personeria juridica, copia de la vigencia de poderes emitida por los Registros Publicos con una antiguedad no mayor de seis (06) meses'){
          tipoDoc = 'AW003';
        }else if(documentos[i].vl_val_parametro == 'Copia del Contrato de Arrendamiento vigente. De no contar con contrato de arrendamiento, o se encuentre vencido y tenga imposibilidad para presentar carta poder suscrita por el propietario, deberá suscribir la declaración jurada'){
          tipoDoc = 'AW004';
        }else if(documentos[i].vl_val_parametro == 'Documento que acredite que se encuentre habilitado para realizar el trámite'){
          tipoDoc = 'AW005';
        }else{
          tipoDoc = 'AW999';
        }*/
        /**Para mostrar la grilla de documentos inicial sin adjuntos */
        datasource.push({
          descTipo: documentos[i].vl_val_parametro,
          disabledAdjuntar: false,
          disabledEliminar: false,
          docAdjunto: ' ',
          estadoDocumento: estadoDoc,
          flagDocumentHabilitado: true,
          id: i + 1,
          idBandeja: 0,
          idBandejaDoc: 0,
          motivoRechazo: ' ',
          tieneDocumento: false,
          tipo: documentos[i].tipo
        })
      }


    }

    this.dataSource = datasource;

  }

  emitNombre(event: any) {
    this.solicitante.nombres = event;
  }

  emitMaterno(event: any) {
    this.solicitante.materno = event;
  }

  emitPaterno(event: any) {
    this.solicitante.paterno = event;
  }

  labelDefecto() {
    this.labelname = 'Nombre(s)';
    this.labelapep = 'Apellido Paterno';
    this.labelapem = 'Apellido Materno';
    this.labelmail = 'Correo';
  }

  labelJuridico() {
    this.labelname = this.labelname + ' RRLL';
    this.labelapep = this.labelapep + ' RRLL';
    this.labelapem = this.labelapem + ' RRLL';
    this.labelmail = this.labelmail + ' Principal';
    this.tipoPersona = 'PS002'; // Juridica
  }

}
